import styled from "styled-components";
import { mediaMaxWidth } from "../../utils/mediaQueriesTemplate";

export const AgentInfoWrapper = styled.div`
  background: #673490;
  color: #fff;
  border-radius: 8px;
  padding: 15px;
  margin: 20px 0;
  height: fit-content;
  box-shadow: 0 0 15px #dcdcdc;
  font-family: Raleway;
  display: flex;
  justify-content: flex-start;

  ${mediaMaxWidth.tablet`
    margin: 0;
  `}
`;

export const AgentInfo = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
`;

export const AgentAvatar = styled.div`
  display: flex;
  flex: 1;
`;

export const AgentPersonalInfo = styled.div`
  padding: 0 15px;
  display: flex;
  flex: 3;
  flex-direction: column;
`;

export const AgentImg = styled.img`
  width: 65px;
  height: 65px;
  object-fit: cover;
  border-radius: 50%;
  margin: 0 5px;
  overflow: hidden;

  ${mediaMaxWidth.phone`
    width: 50px;
    height: 50px;
  `}
`;

export const AgentName = styled.div`
  font-size: 1.2em;
  font-weight: 600;
  margin-top: 10px;

  ${mediaMaxWidth.phone`
    font-size: 1em;
  `}
`;

export const AgentCompany = styled.div`
  font-size: 0.9em;
  font-weight: 500;
  margin-bottom: 15px;

  ${mediaMaxWidth.phone`
    font-size: 0.8em;
  `}
`;

export const AgentMessage = styled.div`
  width: 65px;
  height: 65px;
  margin: 0 10px 0 auto;
  display: flex;

  ${mediaMaxWidth.phone`
    width: 50px;
    height: 50px;
  `}
`;

export const MessageLink = styled.div`
  height: 100%;
  width: 100%;
  background: #f2008c;
  border-radius: 50%;
  transition: 0.1s ease-in-out;

  svg {
    margin: 19px 16px;
    color: #fff;
    font-size: 1.8em;

    ${mediaMaxWidth.phone`
      margin: 10px 8px;
    `}
  }

  &:hover {
    cursor: pointer;
    background: #fff;

    svg {
      color: #673490;
    }
  }
`;
